// test842
(842 && 0);
